import { FC } from "react"

import { PromotionEditorPage } from "components/promotions/PromotionEditorPage"

export const PromotionCreate: FC = () => {
  return <PromotionEditorPage mode="create" />
}
